import { Controller } from "stimulus";

export default class StickyShadowController extends Controller {
  connect() {
    this.mediaQuery = window.matchMedia("(min-width: 768px)");

    this.boundScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.boundScroll, { passive: true });

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", this.boundScroll);
    } else {
      this.mediaQuery.addListener(this.boundScroll);
    }

    this.handleScroll();
  }

  disconnect() {
    if (this.boundScroll) {
      window.removeEventListener("scroll", this.boundScroll);

      if (this.mediaQuery?.removeEventListener) {
        this.mediaQuery.removeEventListener("change", this.boundScroll);
      } else {
        this.mediaQuery?.removeListener(this.boundScroll);
      }
    }
  }

  handleScroll() {
    if (!this.mediaQuery?.matches) {
      delete this.element.dataset.scrolled;
      return;
    }

    if (window.scrollY > 0) {
      this.element.dataset.scrolled = "true";
    } else {
      delete this.element.dataset.scrolled;
    }
  }
}
